import { PDFTextField } from 'pdf-lib'

export const renderUnknownField = (pdfField: PDFTextField) => {
  const [widget] = pdfField.acroField.getWidgets()
  widget.getOrCreateBorderStyle().setWidth(-1)

  pdfField.setText('')
  pdfField.enableReadOnly()
}
